const relationshipTypesByValue = {
  1: "Unidirectional One-to-One",
  2: "One to One",
  3: "One to Many",
  4: "Many to Many",
  5: "Many to One",
  6: "One-to-Many Relationship"
};

export function RelationSelect(type, id, parent) {
  switch (relationshipTypesByValue[type]) {
    case "One to One":
      return false;

    case "Many to Many":
      return true;

    case "One to Many":
    case "One-to-Many Relationship":
      return !!parent;

    case "Many to One":
      return !parent;

    default:
      return false;
  }
}
